export default __webpack_public_path__ + "static/media/wedding.d7589009.svg";